import { Box, Button, useMediaQuery } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import image from "../assets/Thankyou.png";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { Typography } from '@mui/material';


const Thankyou = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId;
  console.log("userid", userId);
  const handleprofdetails = () => {
    navigate("/professionaldetails", { state: { userId } });
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <>
    {isSmallScreen ?(<span> <Box sx={styles.formboxresponsive}>
      <Box
        onClick={handleCancel}
        sx={{
          textAlign: "right",
          cursor: "pointer",
          color: "#666666",
        }}
      >
        <CloseIcon />
      </Box>
      <img src={image} alt="logo" />
      <Typography sx={{fontSize:"20px",fontWeight:"bold",marginTop:"4px"}}>Thank you!</Typography>
      <div>You are almost done. There are few more steps to complete the partnership registration.
      </div>
      <Button sx={styles.btn} onClick={handleprofdetails}>
        Let's Continue
      </Button>
    </Box></span>):(<span> <Box sx={styles.formbox}>
      <Box
        onClick={handleCancel}
        sx={{
          textAlign: "right",
          cursor: "pointer",
          color: "#666666",
        }}
      >
        <CloseIcon />
      </Box>
      <img src={image} alt="logo" />
      <Typography sx={{fontSize:"20px",fontWeight:"bold",marginTop:"4px"}}>Thank you!</Typography>
      <div>You are almost done. There are few more steps to complete the partnership registration.
      </div>
      <Button sx={styles.btn} onClick={handleprofdetails}>
        Let's Continue
      </Button>
    </Box></span>)}
    </>
   
  );
};

export default Thankyou;
const styles = {
  formbox: {
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "400px",
    // height:"calc(100vh - 250px)",
    width: "420px",
  },
  formboxresponsive: {
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "15px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "400px",
    // height:"calc(100vh - 250px)",
    width: "320px",
  },
  formboxtwo: {
    position: "absolute",
    top: "90%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "30px",
    width: "520px",
  },
  btn: {
    marginTop: "2em",
    width: "12em",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
